import debounce  from 'lodash/debounce'
import React from 'react'
import Translation from '../global/Translation'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import { quotationMessages } from './PreOrdersCtsContainer'
import { BudgetMessages } from '../cut-to-size/CutToSizeMaps'
import { StatusList } from './PreOrdersCts'

class PreOrdersCtsFilters extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            // startDate: moment().add(-90, 'days'),
            // endDate: moment(),
            // filterProject: null,
            // filterTypeOrder: null,
            // showDetails: false,
            search:''
        }
    }

    currentDate = moment()

    componentDidMount() {

    }

    changeTypeOrder = e => {
        // this.setState({ filterTypeOrder: e ? e.value : null }, () => this.fetchOrders())
        this.props.updateFilterValues(this.props.startDate, this.props.endDate, this.props.filterProject, e ? e.value : null, this.props.search)
    }

    changeStartDate = date => {
        // this.setState({ startDate: date, endDate: this.getMaxDate(date) }, () => this.fetchOrders())
        this.props.updateFilterValues(date, this.getMaxDate(date), this.props.filterProject, this.props.filterTypeOrder, this.props.search)
    }

    changeEndDate = date => {
        // this.setState({ endDate: date }, () => this.fetchOrders())
        this.props.updateFilterValues(this.props.startDate, date, this.props.filterProject, this.props.filterTypeOrder, this.props.search)
    }

    changeTypeProject = e => {
        // this.setState({ filterProject: e ? e.value : null }, () => this.fetchOrders())
        this.props.updateFilterValues(this.props.startDate, this.props.endDate, e ? e.value : null, this.props.filterTypeOrder, this.props.search)
    }

    // fetchOrders = () => {
    //     this.props.fetchPreOrdersCtsPaginate(this.state.startDate, this.state.endDate, this.state.filterProject, this.state.filterTypeOrder, this.state.search, 1)
    // }

    searchDebounce = debounce(() => {
        if ((this.state.search && this.state.search.length > 1) || (!this.state.search || this.state.search.length === 0)) {
            this.props.updateFilterValues(this.props.startDate, this.props.endDate, this.props.filterProject, this.props.filterTypeOrder, this.state.search)
            // this.fetchOrders()
        }
    }, 500)
    
    getMaxDate = (startDate) => {
        if (!startDate) { startDate = this.state.startDate }
        const startDatePlus12Months = moment(startDate).add(12, 'month')
        return startDatePlus12Months.diff(this.currentDate, 'seconds') > 0 ? this.currentDate : startDatePlus12Months
   }

    render() {
        const inputProjectType = (
            <Select
                options={
                    this.props.projectList &&
                    this.props.projectList.length > 0 &&
                    this.props.projectList.map(item => {
                        return {
                            label: this.props.intl.formatMessage({ id: BudgetMessages[item.project].id }),
                            value: item.project
                        }
                    })
                }
                value={this.props.filterProject}
                clearable={true}
                onChange={this.changeTypeProject}
                className={`p-0 Select--sm form-control form-control-sm flex-grow-1`}
            />
        )
        const inputDateFrom = (
            <DatePicker
                selected={this.props.startDate}
                selectsStart={true}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                // maxDate={moment().add(12, 'month')}
                maxDate={this.currentDate}
                onChange={selectedOption => this.changeStartDate(selectedOption, 'startDate')}
                // onFocus={() => this.setState({ endDate: null })}
                autoComplete="off"
                onKeyDown={e => e.preventDefault()}
                showMonthDropdown
                showYearDropdown
                isClearable={true}
                className={`form-control form-control-sm date`}
            />
        )
        const inputDateTo = (
            <DatePicker
                selected={this.props.endDate}
                selectsEnd
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                minDate={this.props.startDate}
                maxDate={this.getMaxDate()}
                onChange={selectedOption => this.changeEndDate(selectedOption, 'endDate')}
                autoComplete="off"
                onKeyDown={e => e.preventDefault()}
                showMonthDropdown
                showYearDropdown
                isClearable={true}
                // disabled={!this.state.startDate}
                className={`form-control form-control-sm date`}
            />
        )
        const inputStatus = (
            <Select
                options={StatusList.map(item => {
                    return {
                        label: this.props.intl.formatMessage({ id: quotationMessages[item].id }),
                        value: item
                    }
                })}
                value={this.props.filterTypeOrder}
                clearable={true}
                onChange={this.changeTypeOrder}
                className={`p-0 Select--sm form-control form-control-sm flex-grow-1`}
            />
        )
        const inputSearch = (
            <input
                type="text"
                data-qa="query"
                placeholder={this.props.intl.formatMessage({
                    id: 'search'
                })}
                value={this.state.search}
                onChange={e => this.setState({ search: e.target.value })}
                onKeyUp={this.searchDebounce}
                onPaste={this.searchDebounce}
                className={`search-box form-control form-control-sm`}
            />
        )

        return (
            <div className="row order_filters">
                {this.props.type !== 'transfer' && (
                    <React.Fragment>
                        <div
                            className={`col-12 col-lg-10  order-1 order-sm-1   group_date_picker justify-content-between d-sm-block my-1`}
                        >
                            <div className="row">
                                <div className={'col-12 col-lg-3 pl-lg-0 pr-lg-2 px-0'}>
                                    <div className="name">
                                        <Translation id="project_type" defaultMessage="Project type" />
                                    </div>
                                    {inputProjectType}
                                </div>

                                <div className="group_date_picker__item col-6 col-lg-3 px-lg-2 pl-0 mt-2 mt-lg-0">
                                    <div className="name">
                                        <Translation id="from" defaultMessage="From" /> <i className="fal fa-chevron-down" />
                                    </div>
                                    {inputDateFrom}
                                </div>

                                <div className="group_date_picker__item col-6 col-lg-3 px-lg-2 pr-0 mt-2 mt-lg-0">
                                    <div className="name">
                                        <Translation id="to" defaultMessage="To" /> <i className="fal fa-chevron-down" />
                                    </div>
                                    {inputDateTo}
                                </div>

                                <div className={'col-12 col-lg-3 px-lg-2 px-0 mt-2 mt-lg-0'}>
                                    <div className="name">
                                        <Translation id="status" defaultMessage="Status" />
                                    </div>
                                    {inputStatus}
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-2  order-2 order-sm-4 order-lg-2 mt-3 my-lg-1 pr-lg-0 pl-lg-2 px-0">
                            <div className={'d-sm-flex align-items-end'} style={{ height: '100%' }}>
                                <div className="search-bar search-bar--thin w-100" style={{ minWidth: 'fit-content' }}>
                                    {inputSearch}
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </div>
        )
    }
}

export default injectIntl(PreOrdersCtsFilters)
